export default function BoltOutlineIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z'
      />
    </svg>
  )
}
